import React, { useState } from "react"
import { Card, CardBody, Collapse, Label } from "reactstrap"
import classnames from "classnames"

const UserListreportaccordian = props => {
  const { userlist } = props

  const [handleAccordion, sethandleAccordion] = useState(false)
  const handleOnclickAccordion = value => {
    if (handleAccordion === value) {
      sethandleAccordion(null)
    } else {
      sethandleAccordion(value)
    }
  }

  return (
    <>
      <Card>
        <CardBody>
          {userlist?.map((rep, keyId) => (
            <div className="accordion" id="accordion" key={keyId}>
              <div className="accordion-item mb-2">
                <h2 className="accordion-header" id="headingOne">
                  <button
                    className={classnames("accordion-button", "fw-medium", {
                      collapsed: handleAccordion === keyId,
                    })}
                    type="button"
                    onClick={() => handleOnclickAccordion(keyId)}
                    style={{ cursor: "pointer" }}
                  >
                    {rep?.userName}
                    <span style={{ position: "absolute", right: "8%" }}>
                      {rep?.totalHoursWorked}
                    </span>
                  </button>
                </h2>
                <Collapse
                  isOpen={handleAccordion !== keyId}
                  className="accordion-collapse"
                >
                  <div className="accordion-body">
                    <div className="text-muted">
                      <div className="mb-3">
                        <Label className="form-label">
                          <strong>Reports:</strong>{" "}
                        </Label>
                        <div
                          className="input-static-width"
                          dangerouslySetInnerHTML={{
                            __html: rep?.workReportSummary,
                          }}
                        ></div>
                      </div>
                    </div>
                  </div>
                </Collapse>
              </div>
            </div>
          ))}
        </CardBody>
      </Card>

      {userlist === null && (
        <Card>
          <CardBody>
            <div>
              <div className="text-center">No Records Found</div>
            </div>
          </CardBody>
        </Card>
      )}
      {userlist?.length === 0 && (
        <Card>
          <CardBody>
            <div>
              <div className="text-center">No Records Found</div>
            </div>
          </CardBody>
        </Card>
      )}
    </>
  )
}

export default UserListreportaccordian
